import React, { useLayoutEffect } from 'react';
import {
  PageContainer,
  ContentContainer,
  Content,
  Title,
  Text,
  StyledList,
  StyledLi,
  DateSubtitle,
} from './Hikes.styles';

export const Rumunia2026: React.FC = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <ContentContainer>
        <Content>
          <Title>Bukareszt + Karpaty</Title>
          <DateSubtitle>26.06-03.07.2026 | 6 miejsc</DateSubtitle>
          <Text>
            Bukareszt na start, potem Karpaty - 3 trekkingi o zróżnicowanej długości i klimat okolic
            Bran. Elastycznie i z przestrzenią.
          </Text>

          <Text style={{ marginBottom: '5px' }}>
            <strong>Harmonogram:</strong>
          </Text>
          <StyledList>
            <StyledLi>26.06 - przylot do Bukaresztu</StyledLi>
            <StyledLi>27.06 - Muzeum Wsi Dimitrie Gusti, Pałac Parlamentu</StyledLi>
            <StyledLi>
              28.06 - Zamek Peleș, Kanion 7 Drabinilor (krótki trekking), przejazd w stronę Karpat
            </StyledLi>
            <StyledLi>29.06 - trekking 15-18 km</StyledLi>
            <StyledLi>30.06 - dzień wolny w Bran: Zamek Bran, muzeum, kawa, zakupy</StyledLi>
            <StyledLi>01.07 - trekking 18-22 km</StyledLi>
            <StyledLi>02.07 - Zărnești i trekking 16-18 km</StyledLi>
            <StyledLi>03.07 - śniadanie w Brașov, przejazd na lotnisko i wylot</StyledLi>
          </StyledList>

          <Text style={{ marginBottom: '5px' }}>
            <strong>W cenie:</strong>
          </Text>
          <StyledList>
            <StyledLi>noclegi: 7 nocy (Bukareszt + Bran)</StyledLi>
            <StyledLi>
              transport na miejscu (wynajem, ubezpieczenie, paliwo, autostrady, parkingi)
            </StyledLi>
            <StyledLi>pełna organizacja i logistyka</StyledLi>
            <StyledLi>3 trekkingi</StyledLi>
            <StyledLi>wybrane wejściówki</StyledLi>
            <StyledLi>ubezpieczenie turystyczne</StyledLi>
          </StyledList>
          <Text style={{ marginBottom: '5px' }}>
            <strong>Dodatkowo płatne:</strong>
          </Text>
          <StyledList>
            <StyledLi>wyżywienie</StyledLi>
            <StyledLi>loty</StyledLi>
            <StyledLi>atrakcje dodatkowe</StyledLi>
          </StyledList>
        </Content>
      </ContentContainer>
    </PageContainer>
  );
};

export default Rumunia2026;
